var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomizeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9935_150800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.265 6.708a1.25 1.25 0 1 0 .642 2.416 1.25 1.25 0 0 0-.642-2.416",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.093 4.208a1.25 1.25 0 1 0 .642 2.417 1.25 1.25 0 0 0-.642-2.417m-4.164 2.5a1.25 1.25 0 1 0 .642 2.417 1.25 1.25 0 0 0-.642-2.417m0 5a1.25 1.25 0 1 0 .642 2.417 1.25 1.25 0 0 0-.642-2.417",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.418.006A10 10 0 0 0 .07 10a10.01 10.01 0 0 0 10 10c.282 0 .559-.019.834-.042a.833.833 0 0 0 .763-.833l-.027-2.99A2.973 2.973 0 0 1 16.715 14l.084.083a1.6 1.6 0 0 0 1.474.434 1.57 1.57 0 0 0 1.147-.98c.46-1.209.68-2.495.648-3.787a10.13 10.13 0 0 0-9.65-9.744m7.485 12.833-.012-.012a4.639 4.639 0 0 0-7.917 3.321l.02 2.185a8.334 8.334 0 1 1 .37-16.662 8.44 8.44 0 0 1 8.037 8.12 8.2 8.2 0 0 1-.496 3.042z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9935_150800"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeIcon);
export default __webpack_public_path__ + "static/media/customize-icon.22099cb89edfd76f4ee5191fe0d26db9.svg";
export { ForwardRef as ReactComponent };